module.exports = __webpack_public_path__ + "static/salt5-4298b18855abe74776b12b971cf2003d.png";